module.exports = __webpack_public_path__ + "static/media/circle-check.fb20e8f7.svg";